<template>
	<div class="progress-steps">
		<p>{{ step || 1 }}/{{ totalSteps }}</p>
		<ul class="progress-steps">
			<li
				v-for="index in totalSteps"
				:key="index"
				:class="[(index < currentStep ? 'done' : ''), (index === currentStep ? 'active' : '')]"
			>
				<a
					v-if="index < currentStep"
					href="#"
					@click.prevent="onChange(index - 1)"
				>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'ProgressSteps',
	props: {
		step: {
			type: Number,
			default: 1,
		},
		onChange: {
			type: Function,
			default: () => 1,
		},
	},
	data() {
		return {
			currentStep: parseInt(this.step),
		};
	},
	computed: {
		...mapState({
			steps: state => state.progress.steps,
		}),
		totalSteps() {
			return this.$store.getters['progress/totalSteps'];
		},
	},
	updated() {
		this.currentStep = this.step;
	},
};
</script>

<style lang="scss">
.progress-steps p {
	color: #B9B9B9;
	font-size: 14px;
	margin: 0;
}

.progress-steps ul{
	display: block;
	list-style-type: none;
	margin: 0;
	padding: 0 5px;
}

.progress-steps ul li {
	background-color: #A7A7A7;
	border-radius: 50%;
	color: transparent;
	height: 8px;
	margin: 6px;
	width: 8px;

	&.active {
		background: #62BBE9;
	}

	&.done {
		background-color: #4A4A4A;
	}

	a {
		display: block;
		height: 100%;
		width: 100%;
	}
}
</style>
